import React from 'react';
import { useTranslation } from 'react-i18next';
import GuidePage from './GuidePage';
import GuidePageEs from './GuidePage_es';

const GuidePageWrapper: React.FC = () => {
    const { i18n } = useTranslation();

    if (i18n.language === 'es') {
        return <GuidePageEs />;
    }

    return <GuidePage />;
};

export default GuidePageWrapper;
